import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcTrashcan(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.28 2.25a1.75 1.75 0 0 1 1.66 1.196l.601 1.804H20.5a.75.75 0 0 1 0 1.5h-.799l-.89 13.366a1.75 1.75 0 0 1-1.747 1.634H6.936a1.75 1.75 0 0 1-1.747-1.634L4.3 6.75H3.5a.75.75 0 0 1 0-1.5h3.959l.602-1.804A1.75 1.75 0 0 1 9.72 2.25zM6.686 20.017a.25.25 0 0 0 .249.233h10.128a.25.25 0 0 0 .25-.233l.884-13.267H5.802zM9.25 17v-7a.75.75 0 0 1 1.5 0v7a.75.75 0 0 1-1.5 0m4 0v-7a.75.75 0 0 1 1.5 0v7a.75.75 0 0 1-1.5 0M9.72 3.75a.25.25 0 0 0-.237.17l-.442 1.33h5.918l-.442-1.33a.25.25 0 0 0-.238-.17z"
  }));
}
var IcTrashcan = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTrashcan));

export { IcTrashcan as I };
